export default __webpack_public_path__ + "static/media/ic_cape_verde.c5c0a92c.svg";